var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThematicCube = function SvgThematicCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.031 64.93"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.739 42.16v-24.6l8.192-4.02-16.413-7.945-2.837-1.375L27.961 0l-8.116 3.9 8.828 4.336-19.382 9.707 9.671 4.66 18.726-9.951 10.022 4.919-9.563 4.592v25.284l-10.07 5.547V40.941L9.235 31.13 9.3 17.947 0 13.455v35.039l9.135 5.359.052-11.4 18.886 10.553V64.93l27.958-16.336v-11z"
  })));
};
export default SvgThematicCube;